import * as types from 'constants/ActionTypes';

/**
 * Store Mobility lodging-checkbox state for the active purchase session.
 * @param {boolean|null} active - Checkbox state from search URL, or null when unset.
 * @returns {object} Redux action.
 */
export function setLodgingCheckboxSession(active) {
  return { type: types.SET_LODGING_CHECKBOX_SESSION, active };
}

/**
 * Clear persisted lodging-checkbox session state.
 * @returns {object} Redux action.
 */
export function resetLodgingCheckboxSession() {
  return { type: types.RESET_LODGING_CHECKBOX_SESSION };
}

export default setLodgingCheckboxSession;
